<template>
  <div
    class="activity-floor-page"
    :style="{ background: activityFloor.background }"
  >
    <div
      class="activity-floor-cover"
      v-if="activityFloor.cover"
      @click="handleClickImage"
    >
      <img :src="activityFloor.cover" class="background-image" />
      <div class="activity-floor-cover-title">{{ activityFloor.title }}</div>
      <div class="activity-floor-cover-introduction">
        {{ activityFloor.introduction }}
      </div>
    </div>
    <div>
      <template v-if="activityFloor.content_type === 1">
        <div class="activity-floor-content">
          <FloorProduct
            v-for="item in activityFloor.content"
            :key="item.visa_product_id"
            :contentInfo="item"
          ></FloorProduct>
        </div>
      </template>
      <template v-if="activityFloor.content_type === 2">
        <div class="activity-floor-content">
          <FloorCoupon
            v-for="item in activityFloor.content"
            :key="item.id"
            :contentInfo="item"
            @get-coupon="getCoupon"
          ></FloorCoupon>
        </div>
      </template>
      <div
        class="activity-floor-button-box"
        v-if="activityFloor.button_content"
      >
        <div @click="handleClickButton" class="activity-floor-buttom">
          {{ activityFloor.button_content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloorProduct from './floor-product.vue';
import FloorCoupon from './floor-coupon.vue';
import utils from '../../../services/tools.js';

export default {
  name: 'activity-floor',
  components: {
    FloorProduct,
    FloorCoupon,
  },
  data() {
    return {
      is_in_app: 0,
      tabBarList: [
        '/pages/index/index',
        '/pages/order/order',
        '/pages/my/profile/profile',
      ],
    };
  },
  props: {
    activityFloor: Object,
  },
  created() {
    this.is_in_app = this.$route.query.is_in_app || 0;
  },
  methods: {
    handleClickButton() {
      let url = '';
      if (utils.isWxa() && this.activityFloor.button_wxa) {
        // 小程序内
        // 填写了小程序链接
        // 是否链接是小程序的tabbar

        if (this.tabBarList.indexOf(this.activityFloor.button_wxa) > -1) {
          wx.miniProgram.switchTab({ url: this.activityFloor.button_wxa });
        } else {
          wx.miniProgram.navigateTo({ url: this.activityFloor.button_wxa });
        }
        return;
      } else if (this.is_in_app && this.activityFloor.scheme) {
        url = this.activityFloor.scheme;
      } else {
        url = this.activityFloor.button_url;
      }
      if (url) {
        window.location.href = url;
      }
    },
    handleClickImage() {
      let url = '';
      if (utils.isWxa() && this.activityFloor.background_wxa) {
        // 小程序内
        // 填写了小程序链接
        // 是否链接是小程序的tabbar
        if (this.tabBarList.indexOf(this.activityFloor.background_wxa) > -1) {
          wx.miniProgram.switchTab({ url: this.activityFloor.background_wxa });
        } else {
          wx.miniProgram.navigateTo({ url: this.activityFloor.background_wxa });
        }
        return;
      } else if (this.is_in_app && this.activityFloor.background_scheme) {
        url = this.activityFloor.background_scheme;
      } else {
        url = this.activityFloor.background_link;
      }
      if (url) {
        window.location.href = url;
      }
    },
    getCoupon(code, couponInfo) {
      this.$emit('get-coupon', code, couponInfo);
    },
  },
};
</script>
<style lang="less" scoped>
.activity-floor-page {
  box-sizing: border-box;
}
.activity-floor-cover {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  box-sizing: border-box;
  position: relative;
  .background-image {
    width: 100%;
  }
  .activity-floor-cover-title {
    font-size: 0.27rem;
    color: #ffffff;
    position: absolute;
    top: 0.5rem;
    left: 50%;
    text-align: center;
    transform: translateX(-50%);
  }
  .activity-floor-cover-introduction {
    font-size: 0.14rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.18rem;
    top: 1.4rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
// .activity-floor-content{
//   padding: 0rem 0.1rem 0.15rem 0.1rem;
// }
// .activity-floor-content + .activity-floor-button-box{
//   padding-top: 0.05rem;
// }
.activity-floor-button-box {
  padding: 0.2rem 0;
  text-align: center;
  .activity-floor-buttom {
    width: 2.4rem;
    font-size: 0.16rem;
    color: #fff;
    font-weight: 600;
    padding: 0.13rem 0;
    border-radius: 0.22rem;
    background-image: linear-gradient(-10deg, #ff5a60 0%, #f97a79 100%),
      linear-gradient(#f58bac, #f58bac);
    box-shadow: 0rem 0.03rem 0.1rem 0rem rgba(0, 0, 0, 0.1);
    display: inline-block;
  }
}
</style>
